import {Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges} from '@angular/core';
import {FormGroup, FormBuilder} from '@angular/forms';
import {EventFormService} from './event-form.service';
import {ThingsService} from '../../things.service';
import {AuthService} from '../../../auth/auth.service';
import {EntityService} from '../../../core/entity.service';

@Component({
  selector: 'nuc-event-simulation',
  templateUrl: './event-simulation.component.html',
  styleUrls: ['./event-simulation.component.scss']
})
export class EventSimulationComponent implements OnInit, OnChanges {

  @ViewChild('popup') eventSimulationPopup;
  @Input() schema;
  @Input() thing;
  @Input() isLoading? = false;
  @Input() hasNonStringAttribute = true;
  @Output() eventSimulated: EventEmitter<any> = new EventEmitter<any>();
  @Output() eventCanceled: EventEmitter<any> = new EventEmitter<any>();
  form: FormGroup;
  locationForm: FormGroup;
  isSubmitted = false;

  constructor(private evtForm: EventFormService,
              private thingService: ThingsService,
              private authService: AuthService,
              private entityService: EntityService) {
  }

  buildForm(schema) {
    this.form = this.evtForm.toFormGroup(schema.attributes);
    this.locationForm = this.evtForm.locationToForm(schema.location);
  }

  ngOnInit() {
    this.form = new  FormGroup({});
    this.locationForm = new  FormGroup({});
  }

  simulateEvent(form, locationForm) {
    this.isSubmitted = true;
    if (!form.valid || !locationForm.valid) {
      return;
    }
    this.isLoading = true;
    let data = {
      accountId : this.authService.getCurrentAccount().id,
      deviceId: this.thing.token ,
      timestamp: new Date().getTime(),
      location: locationForm.value,
    };
    let event = this.entityService.merge(data, form.value);
    this.thingService.publishEvent(data)
      .subscribe(
        response =>
          setTimeout(() => {
            this.isSubmitted = false;
            this.stopLoader();
            this.eventSimulated.emit(event);
          }, 1000),
        error => {this.isSubmitted = false; this.stopLoader();});
  }

  ngOnChanges() {
    this.buildForm(this.schema);
  }

  open(schema) {
    this.buildForm(schema);
  }

  close() {
    this.eventCanceled.emit(true);
  }

  stopLoader() {
    this.isLoading = false;
  }



}



// WEBPACK FOOTER //
// ./src/app/things/things-details/event-simulation/event-simulation.component.ts